import { render, staticRenderFns } from "./WalletComponent.vue?vue&type=template&id=1d35c9de&scoped=true"
import script from "./WalletComponent.vue?vue&type=script&lang=js"
export * from "./WalletComponent.vue?vue&type=script&lang=js"
import style0 from "./WalletComponent.vue?vue&type=style&index=0&id=1d35c9de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d35c9de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d35c9de')) {
      api.createRecord('1d35c9de', component.options)
    } else {
      api.reload('1d35c9de', component.options)
    }
    module.hot.accept("./WalletComponent.vue?vue&type=template&id=1d35c9de&scoped=true", function () {
      api.rerender('1d35c9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wallet/WalletComponent.vue"
export default component.exports